import React from 'react';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';

const Index = ({ value, onChange, option1, label1, option2, label2 }) => {
  return (<div>
    <ToggleButtonGroup value={value} exclusive onChange={onChange}>
      <ToggleButton value={option1}>
        {label1}
      </ToggleButton>
      <ToggleButton value={option2}>
        {label2}
      </ToggleButton>
    </ToggleButtonGroup>
  </div>);
};

export default Index;


// WEBPACK FOOTER //
// ./src/components/Common/TwoWayToggle/index.js